import { Assert } from '@cotera/utilities';
import {
  ActionResult,
  ApplicableContext,
  BaseAction,
  ExecuteContext,
} from '../framework';
import { z } from 'zod/v3';
import { ok } from 'neverthrow';

export class CloseTabAction extends BaseAction<{}, { t: string }[]> {
  title = 'Close Tab';
  description = 'Close the current tab';
  icon = 'x';
  group = 'General';
  inputSchema = z.object({
    id: z.string(),
  });

  constructor(
    private readonly navigator: {
      close: (id: string) => void;
      activeTab: string | null;
    }
  ) {
    super();
  }

  applicable(_: ApplicableContext): boolean {
    return this.navigator.activeTab !== null;
  }

  async execute(
    { id }: { id: string },
    _2: ExecuteContext
  ): Promise<ActionResult<{ t: string }[]>> {
    Assert.assert(this.navigator.activeTab !== null, 'Active tab not found');

    this.navigator.close(id);

    return ok({});
  }
}
